import functions from "@/utils/functions";
import VueRouter from "vue-router";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import Vue from "vue";
import Viser from "viser-vue";
import Antd from "ant-design-vue/es";
import Print from "vue-print-nb";
import htmlToPdf from "@/utils/htmlToPdf";
import 'ant-design-vue/dist/antd.css';

import dragModal from './drag-modal';
// 导入模板配置初始化
import { initializeTemplateConfig } from '@/config/templates';

Vue.directive('drag-modal', dragModal);

Vue.config.productionTip = false;
Vue.prototype.$functions = functions;
Vue.use(VueRouter);
Vue.use(Viser);
Vue.use(Antd);
Vue.use(Print);
Vue.use(htmlToPdf);

// 应用启动时初始化模板配置（异步，不阻塞应用启动）
initializeTemplateConfig().catch(() => {
  // 静默处理初始化失败，使用默认值
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
